(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["main-article-overlay"]) return;
  try {
    

	const articleBody = document.getElementById('addAnchorLinks');

	if (articleBody) {
		const headings = articleBody.querySelectorAll('h1, h2, h3, h4, h5, h6');

		headings.forEach((heading) => {
			const text = heading.querySelector('span').textContent.replace(/\s+/g, '-').toLowerCase();
			heading.setAttribute("id", text);
			heading.classList.add("anchor-link")
		});
	}


  } catch(e) { console.error(e); }
})();
      })();
